export const PLAYER_PITCH_VIS_FILTER_SOURCE = 'Player Pitch Vis';
export const TEAM_PITCH_VIS_FILTER_SOURCE = 'Team Pitch Vis';
export const PLAYER_DASHBOARD_FILTER_SOURCE = 'Player Dashboard';
export const TEAM_DASHBOARD_FILTER_SOURCE = 'Team Dashboard';
export const PLAYER_RADAR_FILTER_SOURCE = 'Player Radar';
export const TEAM_RADAR_FILTER_SOURCE = 'Team Radar';
export const TEAM_SQUAD_FILTER_SOURCE = 'Team Squad';

// Scope and context tab filters only — for pages without pass/event filters (dashboard, radar, squad)
export const SCOPE_CONTEXT_FILTER_KEYS = [
  // Scope tab
  'competitionIds',
  'seasonIds',
  'teamIds',
  'playerIds',
  'positions',
  // Context tab
  'gameType',
  'gameRange',
  'periodRange',
  'matchPeriods',
  'minMatchMinute',
  'maxMatchMinute',
  'startDate',
  'endDate',
  'deselectedGameIds',
] as const;

export const PITCH_VIS_FILTER_KEYS = [
  // Event filter groups (pass filters — drills into group properties)
  'eventFilterGroups',
  // Pitch zone filters (top-level, separate from eventFilterGroups)
  'pitchStartZones',
  'pitchEndZones',
  // Scope tab
  'competitionIds',
  'seasonIds',
  'teamIds',
  'playerIds',
  'positions',
  // Context tab
  'gameType',
  'gameRange',
  'periodRange',
  'matchPeriods',
  'minMatchMinute',
  'maxMatchMinute',
  'startDate',
  'endDate',
  'deselectedGameIds',
] as const;
